import http from "@/api/http.js";

function listAll() {
  return http({
    url: "/PmsDanone/List",
    method: "get",
  });
}

export default {
  listAll,
};
